module.exports = __webpack_public_path__ + "static/img/photo-forest-03.c8c93fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo-forest-03.jpg
// module id = MJeD
// module chunks = 1